import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_63: FaireProductEntity = {
  token: "catalog_prod_prod-63",
  type: "product",
  name: "Wooden Serving Board - Live Edge - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 76.23,
  msrpDollars: 190.58,
  sku: "JA0063",
  caseSize: 3,
  material: "Linen",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 158,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_bath-body"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
